import CrudManager from '@/components/admin/CrudManager';

// Tier options mirror the public CSR Projects page grouping.
const TIER_OPTIONS = [
    { value: 'education', label: 'Education Projects' },
    { value: 'health', label: 'Health Projects' },
    { value: 'skill-development', label: 'Skill Development Projects' },
    { value: 'green-visionary', label: 'Green Visionary Projects' },
    { value: 'employment', label: 'Employment Projects' },
    { value: 'disaster', label: 'Disaster Projects' },
    { value: 'others', label: 'Others' },
];

const fields = [
    { key: 'title', label: 'Title', type: 'text' },
    { key: 'description', label: 'Short description', type: 'textarea', rows: 2 },
    {
        key: 'tier',
        label: 'Category',
        type: 'select',
        options: TIER_OPTIONS,
    },
    { key: 'file_url', label: 'PDF proposal', type: 'upload-pdf', prefix: 'csr-projects' },
    { key: 'thumbnail_url', label: 'Thumbnail (optional)', type: 'upload-image', prefix: 'csr-projects/thumbs' },
    { key: 'file_size', label: 'File size (display)', type: 'text', placeholder: 'e.g. 1.7 MB' },
    { key: 'order', label: 'Order', type: 'number' },
];

const tierLabel = (t) => TIER_OPTIONS.find((x) => x.value === t)?.label || t;

const columns = [
    { key: 'title', label: 'Title', primary: true },
    { key: 'tier', label: 'Category', render: (r) => tierLabel(r.tier) },
    { key: 'file_size', label: 'Size' },
];

const defaultItem = {
    title: '',
    description: '',
    tier: 'education',
    file_url: '',
    thumbnail_url: '',
    file_size: '',
    order: 99,
};

export default function AdminCSRProjectPDFsPage() {
    return (
        <CrudManager
            resource="csr-project-pdfs"
            title="CSR Project PDFs"
            description="Downloadable PDF proposals shown on the CSR Projects page — grouped by sector (Education, Health, Skill Development, Green Visionary, Employment, Disaster, Others)."
            fields={fields}
            columns={columns}
            defaultItem={defaultItem}
            searchKeys={['title', 'tier']}
        />
    );
}
